
import { Undo, Redo } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Editor } from '@tiptap/react';

export default function UndoRedoButtons({ editor }: { editor: Editor }) {
  return (
    <>
      <Button
        size="icon"
        variant="ghost"
        onClick={e => {
          e.preventDefault();
          editor.chain().focus().undo().run();
        }}
        disabled={!editor.can().chain().focus().undo().run()}
        className="h-8 w-8"
        title="Undo"
        type="button"
      >
        <Undo className="h-4 w-4" />
      </Button>
      <Button
        size="icon"
        variant="ghost"
        onClick={e => {
          e.preventDefault();
          editor.chain().focus().redo().run();
        }}
        disabled={!editor.can().chain().focus().redo().run()}
        className="h-8 w-8"
        title="Redo"
        type="button"
      >
        <Redo className="h-4 w-4" />
      </Button>
    </>
  );
}
